import { IHttpResponse } from "angular";
import { CompatibilityService } from "../services/compatibilityservice";
import { fn } from "../utils";

export function RedirectToInfomaOnlineLogin() {
  var location = window.location.toString();
  var url = "./SignIn";
  const frgIdx = location.indexOf('#');
  if (frgIdx > 0) {
    var part = "./" + location.substring(frgIdx);
    url += "?route=" + encodeURIComponent(part);
  }
  window.location.replace(url);
}

export function InfomaOnlineGuardAuth<T>(this: void, $c: CompatibilityService, guardedAction: () => PromiseLike<angular.IHttpResponse<T>>, retry: boolean = true): PromiseLike<angular.IHttpResponse<T>> {
  return guardedAction().then(fn.identity, (err: IHttpResponse<any>) => {
    if (!retry || typeof (err?.headers) !== "function" || err.headers("infomaonlineauthneeded") !== "true") {
      throw err;
    }
    if (!currentPopupSignInPromise) {
      currentPopupSignInPromise = constructPopupSignPromise($c, err);
    }
    return currentPopupSignInPromise.then(guardedAction);
  });
}

var currentPopupSignInPromise: PromiseLike<any>;

function constructPopupSignPromise($c: CompatibilityService, originalError: IHttpResponse<any>) {
  const currToken = fn.id();
  const currentPopupSignInDeferred = $c.defer();
  currentPopupSignInPromise = currentPopupSignInDeferred.promise;
  const waitForAuth = (e) => {
    if (e.data?.Authenticated === currToken) {

      window.removeEventListener("message", waitForAuth);
      currentPopupSignInDeferred.resolve();
    }
  };
  var tearDown = fn.nullOp;
  $c.resolve("DialogService").ShowWindow({
    windowOptions: {
      modal: true,
      actions: []
    },
    template: `<div align="center" >Die erneute Eingabe Ihrer Anmeldeinformationen ist erforderlich.<br >` +
      ` Sollte Ihr Browser Sie nicht zur erneuten Eingabe auffordern, so laden sie bitte die akutelle Seite erneut!<br ><br >` +
      '<div align="center">' +
      '<button kendo-button inf-operation="vm.Reload">Seite neu laden</button>' +
      '<div>',
    controllerAs: 'vm',
    controller: function () {
      this["Reload"] = {
        Execute: () => {
          tearDown();
          window.location.reload();
        }
      };
    }
  }).then(dlgState => {
    var popupSignInWindow: Window;
    var waitForClose = window.setInterval(() => {
      if (popupSignInWindow?.closed) {
        tearDown();
      }
    }, 200);
    const forceClosePopup = () => popupSignInWindow?.close();
    tearDown = () => {
      window.clearInterval(waitForClose);
      window.removeEventListener("beforeunload", forceClosePopup);
      dlgState.closeDialog();
      currentPopupSignInPromise = undefined;
      currentPopupSignInDeferred.reject(originalError);
      forceClosePopup();
    };
    dlgState.close.then(tearDown);
    currentPopupSignInDeferred.promise.then(tearDown, tearDown);
    window.addEventListener("message", waitForAuth);
    window.setTimeout(() => {
      popupSignInWindow = PopupCenter("./SignIn?route=" +
        encodeURIComponent("./PostModalSignIn?token=" + encodeURIComponent(currToken)), "Anmeldung", 550, 700);
      if (!popupSignInWindow) {
        tearDown();
        throw originalError;
      } else {
        window.addEventListener("beforeunload", forceClosePopup);
        popupSignInWindow.addEventListener("close", tearDown);
      }
    }, 2000);
  });

  return currentPopupSignInPromise;
}

function PopupCenter(url, title, w, h) {
  var screen = window.screen as any;
  var documentElement = document.documentElement;
  // Fixes dual-screen position                         Most browsers      Firefox
  var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
  var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

  const width = window.innerWidth ? window.innerWidth : documentElement.clientWidth ? documentElement.clientWidth : screen.width;
  const height = window.innerHeight ? window.innerHeight : documentElement.clientHeight ? documentElement.clientHeight : screen.height;

  var left = ((width / 2) - (w / 2)) + dualScreenLeft;
  var top = ((height / 2) - (h / 2)) + dualScreenTop;
  var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

  // Puts focus on the newWindow
  if (window.focus && newWindow) {
    newWindow.focus();
  }
  return newWindow;
}
